import { atom, useAtom } from 'jotai';

const deletePendingDialogAtom = atom<string>('');

export const useDeletePendingDialog = () => {
  const [idDeletePendingDialogOpen, setDeletePendingDialogOpen] = useAtom(deletePendingDialogAtom);

  return {
    idDeletePendingDialogOpen,
    setDeletePendingDialogOpen,
  };
};
